import { alpha, styled, TableBody, TableCell } from '@mui/material';

export const CellHeaderStyled = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.global.white,
  fontWeight: theme.typography.subtitle1.fontWeight,
  '&:first-child': {
    width: 30,
  },
  '& + th:nth-child(3)': {
    width: 350,
  },
  '&:last-child': {
    width: 150,
  },
}));

export const TbodyStyled = styled(TableBody)(({ theme }) => ({
  '& tr': {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: alpha(theme.palette.global.lightgray, 0.25),
    },
  },
}));

export const CellBodyStyled = styled(TableCell)({
  alignItems: 'center',
  '& + td:nth-child(3)': {
    '& svg': {
      display: 'none',
    },
  },
});

export const ButtonsActionsStyled = styled(TableCell)(({ theme }) => ({
  height: 52,
  '& .buttonEdit': {
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  '& .buttonDelete': {
    '&:hover': {
      color: '#ff0000',
    },
  },
}));
